import { BEEnum } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEEnumExtend {
  public static Init(dto: BEEnum) {
    dto.bEType = EnumBEType.BEEnum;
  }
}
